export const PointsHistory = () => {
    const pointsHistoryInfo = `{
      user {
        loyalty {
          loyaltyLevelCurrent {
            points {
              currentAvailable
            }
          }
          history {
            id
            points
            date
            enroll
            transSubType
            transSubTypeString
            transType
            transTypeString
            fromTier
            toTier
            order
            transOrderId
            type
            pending
          }
        }
      }
    }
  `;

    return pointsHistoryInfo;
};
